// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"534":"03f5482b","975":"98e37546"}[chunkId] + ".chunk.js";
};